import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProfileRoutingModule } from './profile-routing.module';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { UserSummaryProfileInfoComponent } from './ui-components/user-introduction-info/user-introduction-info.component';
import { UserAboutInfoComponent } from './ui-components/user-summary-info/user-summary-info.component';
import { UserDashboardInfoComponent } from './ui-components/user-dashboard-info/user-dashboard-info.component';
import { UserExperienceInfoComponent } from './ui-components/user-experience-info/user-experience-info.component';
import { UserEducationInfoComponent } from './ui-components/user-education-info/user-education-info.component';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SummaryEditModalComponent } from './ui-components/edit-summary-modal/edit-summary-modal.component';
import { EditProfileInfoModalComponent } from './ui-components/edit-profile-info-modal/edit-profile-info-modal.component';
import { EditProfileContactModalComponent } from './ui-components/edit-profile-contact-modal/edit-profile-contact-modal.component';
import { AddExperienceModalComponent } from './ui-components/add-experience-modal/add-experience-modal.component';
import { AddEducationModalComponent } from './ui-components/add-education-modal/add-education-modal.component';
import { UserSkillsComponent } from './ui-components/user-skills-languages-info/user-skills-info.component';
import { AddSkillModalComponent } from './ui-components/add-skill-modal/add-skill-modal.component';
import { AddLanguageModalComponent } from './ui-components/add-language-modal/add-language-modal.component';
import { DocsUploadComponent } from './docs-upload/docs-upload.component';
import { ConfirmRemoveModalComponent } from './ui-components/confirm-remove-modal/confirm-remove-modal.component';
import { PublicProfileComponent } from './public-profile/public-profile.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ProfessionalSummaryComponent } from './ui-components/professional-summary/professional-summary.component';
import { UserLinksInfoPanelComponent } from './ui-components/user-links-info-panel/user-links-info-panel.component';
import { UserAttachmentsInfoPanelComponent } from './ui-components/user-attachments-info-panel/user-attachments-info-panel.component';
import { UserSocialInfoPanelComponent } from './ui-components/user-social-info-panel/user-social-info-panel.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { UserLanguagesLocationsInfoComponent } from './ui-components/user-languages-locations-info/user-languages-locations-info.component';
import { UserSupportInfoComponent } from './ui-components/user-support-info/user-support-info.component';
import { UserExperienceHeritageComponent } from './ui-components/user-experience-heritage/user-experience-heritage.component';
import { UserLifeGoalInfoComponent } from './ui-components/user-life-goal-info/user-life-goal-info.component';
import { ProfileSideBarComponent } from './ui-components/profile-side-bar/profile-side-bar.component';
import { StepHelloComponent } from './ui-components/step-hello/step-hello.component';
import { StepIdentityComponent } from './ui-components/step-identity/step-identity.component';
import { StepInterestComponent } from './ui-components/step-interest/step-interest.component';
import { StepProffesionalProfileComponent } from './ui-components/step-proffesional-profile/step-proffesional-profile.component';
import { AccountComponent } from './ui-components/account/account.component';
import { StepNotificationComponent } from './ui-components/step-notification/step-notification.component';
import { ProfileHighlightsSectionComponent } from './helpers/profile-highlights-section/profile-highlights-section.component';
import { ProfileDetailsSectionComponent } from './helpers/profile-details-section/profile-details-section.component';
import { EditProfileActionPanelComponent } from './ui-components/edit-profile-action-panel/edit-profile-action-panel.component';
import { AddLifeGoalModalComponent } from './ui-components/add-life-goal-modal/add-life-goal-modal.component';
import { AddMissionModalComponent } from './ui-components/add-mission-modal/add-mission-modal.component';
import { AddInterestAboutAfricaModalComponent } from './ui-components/add-interest-about-africa-modal/add-interest-about-africa-modal.component';
import { AddNeedSupportWithItemsModalComponent } from './ui-components/add-need-support-with-items-modal/add-need-support-with-items-modal.component';
import { PublicModule } from '../public/public.module';
import { AddLookingForItemsModalComponent } from './ui-components/add-looking-for-items-modal/add-looking-for-items-modal.component';
import { AddPersonaModalComponent } from './ui-components/add-persona-modal/add-persona-modal.component';
import { AddSpokenLanguagesModalComponent } from './ui-components/add-spoken-languages-modal/add-spoken-languages-modal.component';
import { AddWorldConnectionsModalComponent } from './ui-components/add-world-connections-modal/add-world-connections-modal.component';
import { AddPrimaryIndustriesModalComponent } from './ui-components/add-primary-industries-modal/add-primary-industries-modal.component';
import { AddOrgTypesModalComponent } from './ui-components/add-org-types-modal/add-org-types-modal.component';
import { AddCausesModalComponent } from './ui-components/add-causes-modal/add-causes-modal.component';
import { AddProfessionalTitleComponent } from './ui-components/add-professional-title/add-professional-title.component';
import { AddExperienceInfoComponent } from './ui-components/add-experience-info/add-experience-info.component';
import { AddPositionTitlesComponent } from './ui-components/add-position-titles/add-position-titles.component';
import { AddSocialLinkComponent } from './ui-components/add-social-link/add-social-link.component';
import { AddCvComponent } from './ui-components/add-cv/add-cv.component';
import { AddStrengthsComponent } from './ui-components/add-strengths/add-strengths.component';
import { AddProfilePicModalComponent } from './ui-components/add-profile-pic-modal/add-profile-pic-modal.component';
import { AddDisplayedLocationModalComponent } from './ui-components/add-displayed-location-modal/add-displayed-location-modal.component';
import { ChangePasswordModalComponent } from './ui-components/change-password-modal/change-password-modal.component';
import { EditPersonalDetailsModalComponent } from './ui-components/edit-personal-details-modal/edit-personal-details-modal.component';
import { AddIndustryModalComponent } from './ui-components/add-industry-modal/add-industry-modal.component';
import { AddCompensationModalComponent } from './ui-components/add-compensation-modal/add-compensation-modal.component';
import { StepProfileSummaryComponent } from './ui-components/step-profile-summary/step-profile-summary.component';
import { AddDateOfBirthModalComponent } from './ui-components/add-date-of-birth-modal/add-date-of-birth-modal.component';
@NgModule({
    declarations: [
        MyProfileComponent,
        UserSummaryProfileInfoComponent,
        UserAboutInfoComponent,
        UserDashboardInfoComponent,
        UserExperienceInfoComponent,
        UserEducationInfoComponent,
        SummaryEditModalComponent,
        EditProfileInfoModalComponent,
        EditProfileContactModalComponent,
        AddExperienceModalComponent,
        AddEducationModalComponent,
        UserSkillsComponent,
        AddSkillModalComponent,
        AddLanguageModalComponent,
        DocsUploadComponent,
        ConfirmRemoveModalComponent,
        PublicProfileComponent,
        ProfessionalSummaryComponent,
        UserLinksInfoPanelComponent,
        UserAttachmentsInfoPanelComponent,
        UserSocialInfoPanelComponent,
        UserLanguagesLocationsInfoComponent,
        UserSupportInfoComponent,
        UserExperienceHeritageComponent,
        UserLifeGoalInfoComponent,
        ProfileSideBarComponent,
        StepHelloComponent,
        StepIdentityComponent,
        StepInterestComponent,
        StepProffesionalProfileComponent,
        AccountComponent,
        StepNotificationComponent,
        ProfileHighlightsSectionComponent,
        ProfileDetailsSectionComponent,
        EditProfileActionPanelComponent,
        AddLifeGoalModalComponent,
        AddMissionModalComponent,
        AddInterestAboutAfricaModalComponent,
        AddNeedSupportWithItemsModalComponent,
        AddLookingForItemsModalComponent,
        AddPersonaModalComponent,
        AddSpokenLanguagesModalComponent,
        AddWorldConnectionsModalComponent,
        AddPrimaryIndustriesModalComponent,
        AddOrgTypesModalComponent,
        AddCausesModalComponent,
        AddProfessionalTitleComponent,
        AddExperienceInfoComponent,
        AddPositionTitlesComponent,
        AddSocialLinkComponent,
        AddCvComponent,
        AddStrengthsComponent,
        AddProfilePicModalComponent,
        AddDisplayedLocationModalComponent,
        ChangePasswordModalComponent,
        EditPersonalDetailsModalComponent,
        AddIndustryModalComponent,
        AddCompensationModalComponent,
        StepProfileSummaryComponent,
        AddDateOfBirthModalComponent,
    ],
    imports: [
        CommonModule,
        ProfileRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        FlexLayoutModule,
        NgbModule,
        MatMenuModule,
        PublicModule,
        MatExpansionModule
    ],
    exports: [
        UserSummaryProfileInfoComponent,
        UserAboutInfoComponent,
        UserDashboardInfoComponent,
        UserEducationInfoComponent,
        UserExperienceInfoComponent,
        UserSkillsComponent,
        StepHelloComponent,
        StepIdentityComponent,
        StepInterestComponent,
        StepProffesionalProfileComponent,
        AccountComponent,
        StepNotificationComponent,
        ProfileHighlightsSectionComponent,
        ProfileDetailsSectionComponent,
        AddIndustryModalComponent,
        AddCompensationModalComponent,
        AddDateOfBirthModalComponent
    ]
})
export class ProfileModule { }
